<template>
  <div class="layout">
    <LangButton />

    <Transition name="layout__view" mode="out-in">
      <RouterView :key="$route.name" class="layout__view" />
    </Transition>

    <NavigationFooter />
    <NavigationTop @toggle-sidenav="isSideNavOpen = !isSideNavOpen" />
    <NavigationSide :is-open="isSideNavOpen" @close="isSideNavOpen = false" />
    <WorkItemOverlay v-if="$global.workItem" />
  </div>
</template>

<script>
import WorkItemOverlay from './components/work-item/WorkItemOverlay.vue'
import LangButton from './components/common/LangButton.vue'

const getLocalizedRoute = (lang, { name, params, query, hash }) => {
  const adjustedName = name.replace(/-\w\w$/, '')
  return { name: `${adjustedName}-${lang}`, params, query, hash }
}

export default {
  name: 'App',
  components: { WorkItemOverlay, LangButton },
  metaInfo: {
    title: 'Art mural textile acoustique',
    titleTemplate: '%s | Marie Dooley'
  },
  data() {
    return {
      isSideNavOpen: false
    }
  },
  watch: {
    '$i18n.locale'(lang) {
      localStorage.setItem('wcd-lang', lang)
    }
  },
  created() {
    if (this.$route.meta.lang !== this.$i18n.locale) {
      this.$router.replace(getLocalizedRoute(this.$i18n.locale, this.$route))
    }

    this.$watch('$route.meta.lang', (toLang, fromLang) => {
      if (!toLang || toLang === fromLang || toLang === this.$i18n.locale) return
      this.$i18n.locale = toLang
    })
  }
}
</script>
